import React, { useState, useEffect } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { withRouter, RouteComponentProps, useParams } from 'react-router-dom';

import { useQuery } from '@apollo/client';

import Dashboard from '../../../../../layouts/Dashboard';
import ListEmergencyRoles from '../../../../../components/Global/EmergencyRoles/List';

import { emergencyRolesInitQuery, Organisation } from './queries';

import styles from './styles';
import { updateEmergencyRole } from './mutations';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  organisation_id: string;
}

const ListEmergencyRolesAdmin = ({ classes, history }: Props): React.ReactElement => {
  const { organisation_id } = useParams<UrlParams>();

  const [organisation, setOrganisation] = useState<Organisation>({
    name: '',
    emergency_roles: [],
  });

  const { data: emergencyRolesInitData, refetch } = useQuery(emergencyRolesInitQuery(organisation_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && emergencyRolesInitData) {
      setOrganisation(emergencyRolesInitData.organisations_by_pk);
    }
    return () => {
      mounted = false;
    };
  }, [emergencyRolesInitData]);

  const handleCreate = () => {
    history.push(`/admin/trusts/${organisation_id}/emergency_roles/create`);
  };

  const handleEdit = (id: string) => {
    history.push(`/admin/trusts/${organisation_id}/emergency_roles/${id}/edit`);
  };

  const handleActiveStatusChange = async (id: string, isActive: boolean) => {
    const updateVariables = {
      pk_columns: {
        id: id,
      },
      set: {
        active: isActive,
      },
    };
    await updateEmergencyRole(updateVariables);

    await refetch();
  };

  return (
    <Dashboard breadcrumbs={[{ label: 'Trusts', link: '/admin/trusts' }, { label: organisation.name, link: `/admin/trusts/${organisation_id}` }, { label: 'Emergency roles' }]}>
      <ListEmergencyRoles items={organisation.emergency_roles} handleCreate={handleCreate} handleEdit={handleEdit} handleActiveStatusChange={handleActiveStatusChange} />
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(ListEmergencyRolesAdmin));
